import { render, staticRenderFns } from "./AnalyzeConceptAskOpinion.vue?vue&type=template&id=1bcbb8ce&scoped=true&"
import script from "./AnalyzeConceptAskOpinion.vue?vue&type=script&lang=ts&"
export * from "./AnalyzeConceptAskOpinion.vue?vue&type=script&lang=ts&"
import style0 from "./AnalyzeConceptAskOpinion.vue?vue&type=style&index=0&id=1bcbb8ce&prod&lang=scss&scoped=true&"
import style1 from "./AnalyzeConceptAskOpinion.vue?vue&type=style&index=1&id=1bcbb8ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcbb8ce",
  null
  
)

export default component.exports